module.exports = __webpack_public_path__ + "img/Best Practices_Leonardo Munalim.1ea68ef8.jpg";